/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListVaultedDataRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ListVaultedDataResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const listVaultedData = (request:ListVaultedDataRequest, options?: CashRequestOptions) => post<ListVaultedDataRequest, ListVaultedDataResponse>("/2.0/cash/list-vaulted-data", request, {...options, rejectOnError: true })